// extracted by mini-css-extract-plugin
module.exports = {"footerbox":"footerbox-2RiLULtV","cooperation":"cooperation-Y-k5amjK","ad":"ad-1vXhNk7r"};